import { BaseModel } from './base/base-model';

export class DependencyMap extends BaseModel<string>{
    Name: string;
    Description: string;
    CloudProvider: string;
    Image?: string;
    ImagePath?: string;
    CollectionDependencies: CollectionDependency[]
    ExecutionEngine?: ExecutionEngine;
    EnvironmentType: EnvironmentType;
    CredentialReferenceType: CredentialReferenceType;
    CommandCollectionEntryIds?: string[];
    ConfigurationPullCommand?: string;
    ProviderCollectionEntryId?: string;
    /** Explicitly enables target-device selection for blueprints using this map. */
    ShowDeviceSelection?: boolean;
    /** Controls whether the deployment wizard accepts more than one target device. */
    AllowMultipleDeviceSelection?: boolean;
    /** Dependency-map IDs accepted by Device.ProviderId for deployment targets. */
    AllowedDependencyMapIds?: string[];
    IntegrateWithIpam?: boolean; 
    RemediationProvider: string;
}


export class CollectionDependency extends BaseModel<string>{
    CollectionEntryId: string;
    CollectionId: string;
    CollectionName: string;
    KeyAttributeId: string;
    RelationTypeId: string;
    InstanceLimit: number;
    IsParent: boolean;
    IsOptional: boolean;
    TemplateCreatorId: string;
    TemplateCreatorParameterAttributes: string[];
    UseTemplateDropdown: boolean;
    UseTemplatePopup: boolean;
    HideChildren: boolean;
    DisplayInBlueprint: boolean;
    ResourceLevel: ResourceLevel
    MissingParentErrorMessage: string;
    SecondaryTemplateCreatorId: string;
    SecondaryTemplateCreatorParameterAttributes: string[];
    ChildCollections: CollectionDependency[];
    CommandCollectionEntryIds?: string[];
}

export enum EnvironmentType {
    Cloud,
    DataCenter,
    SecurityAndManagement
}

export enum ExecutionEngine{
    Ansible,
    Terraform,
    CLI,
}

export enum CredentialReferenceType {
    Unspecified = 0,
    Account = 1,
    DeviceAuthentication = 2
}

export enum ResourceLevel {
    Blueprint,
    Inventory,
    Connectivity,
    Security
}

export interface DependencyMapCatalogRequest {
    Search?: string;
    EnvironmentTypes?: EnvironmentType[];
    ExecutionEngines?: ExecutionEngine[];
    CredentialReferenceTypes?: CredentialReferenceType[];
    Providers?: string[];
    Active?: boolean;
    Sort?: string;
    Order?: string;
    PageNumber: number;
    PageSize: number;
}

export interface DependencyMapCatalogItem {
    Id: string;
    Name: string;
    Description?: string;
    Image?: string;
    Provider?: string;
    EnvironmentType: EnvironmentType;
    ExecutionEngine: ExecutionEngine;
    CredentialReferenceType: CredentialReferenceType;
    ResourceCount: number;
    RootResourceCount: number;
    ResourcePreview: string[];
    BlueprintUsageCount: number;
    DeploymentCount: number;
    LastUsedAt?: string;
    UpdatedDate?: string;
    IntegrateWithIpam: boolean;
    HasRemediation: boolean;
    Active: boolean;
}

export interface DependencyMapCatalogSummary {
    Integrations: number;
    SupportedResources: number;
    CloudProviders: number;
    DataCenterProviders: number;
    ActiveDeployments: number;
}

export interface DependencyMapCatalogResponse {
    Items: DependencyMapCatalogItem[];
    ProviderOptions: string[];
    TotalCount: number;
    Summary: DependencyMapCatalogSummary;
}

export interface DependencyMapExecutionMetadataIssue {
    Id: string;
    Name: string;
    MissingEnvironmentType: boolean;
    MissingExecutionEngine: boolean;
    MissingCredentialReferenceType: boolean;
}

export interface DependencyMapExecutionMetadataReport {
    BatchSize: number;
    InvalidCount: number;
    HasMore: boolean;
    Items: DependencyMapExecutionMetadataIssue[];
}

export interface DependencyMapCredentialAssignment {
    DependencyMapId: string;
    CredentialReferenceType: CredentialReferenceType;
}

export interface DependencyMapCredentialBackfillResult {
    DryRun: boolean;
    Requested: number;
    Changed: number;
    UnchangedIds: string[];
    MissingIds: string[];
}

export interface DependencyMapCatalogMetadataBackfillResult {
    Candidates: number;
    Changed: number;
    HasMore: boolean;
    ChangedIds: string[];
}
